module.exports = __webpack_public_path__ + "img/album14_14.c6238df6.jpg";